import { render, staticRenderFns } from "./paywx.vue?vue&type=template&id=603a8a13&scoped=true&"
import script from "./paywx.vue?vue&type=script&lang=js&"
export * from "./paywx.vue?vue&type=script&lang=js&"
import style0 from "./paywx.vue?vue&type=style&index=0&id=603a8a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a8a13",
  null
  
)

export default component.exports